import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { PasswordGate } from "./components/PasswordGate.js";
import { normalizePasswordHash } from "./passwordHash.js";
import "./style.css";

const el = document.getElementById("root");
if (!el) throw new Error("root element missing");

// Set at build time: VITE_PIRATES_PASSWORD_HASH=<sha-256 hex of password>.
// Empty (dev / local) → no gate.
const rawHash = import.meta.env["VITE_PIRATES_PASSWORD_HASH"] as
  | string
  | undefined;
const expectedHash = normalizePasswordHash(rawHash);

createRoot(el).render(
  <StrictMode>
    <PasswordGate expectedHash={expectedHash}>
      <App />
    </PasswordGate>
  </StrictMode>,
);
